module.exports = __webpack_public_path__ + "c0200f7f55344c2e12ff166d1a6afc42.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/news6.jpg
// module id = 202
// module chunks = 0